import React from "react";
import { useState } from "react";

import imageOne from "../../../assets/lesson 6.1.png";
import imageTwo from "../../../assets/lesson 5.2.png";

function LessonSix() {
  const [q1, setQ1] = useState("");
  const [q2, setQ2] = useState("");
  const [q3, setQ3] = useState("");
  const [q4, setQ4] = useState("");
  const [q5, setQ5] = useState("");
  const [q6, setQ6] = useState("");
  const [q7, setQ7] = useState("");
  const [q8, setQ8] = useState("");
  const [q9, setQ9] = useState("");
  const [q10, setQ10] = useState("");
  const [q11, setQ11] = useState("");
  const [q12, setQ12] = useState("");
  const [q13, setQ13] = useState("");
  const [q14, setQ14] = useState("");
  const [q15, setQ15] = useState("");
  const [q16, setQ16] = useState("");
  const [q17, setQ17] = useState("");
  const [q18, setQ18] = useState("");
  const [q19, setQ19] = useState("");
  const [q20, setQ20] = useState("");
  const [q21, setQ21] = useState("");
  const [q22, setQ22] = useState("");
  const [q23, setQ23] = useState("");
  const [q24, setQ24] = useState("");
  const [q25, setQ25] = useState("");
  const [q26, setQ26] = useState("");
  const [q27, setQ27] = useState("");
  const [q28, setQ28] = useState("");
  const [q29, setQ29] = useState("");
  const [q30, setQ30] = useState("");
  const [q31, setQ31] = useState("");
  const [q32, setQ32] = useState("");
  const [q33, setQ33] = useState("");
  const [q34, setQ34] = useState("");
  const [q35, setQ35] = useState("");
  const [q36, setQ36] = useState("");
  const [q37, setQ37] = useState("");
  const [q38, setQ38] = useState("");
  const [q39, setQ39] = useState("");
  const [q40, setQ40] = useState("");
  return (
    <>
      <div className="">
        <div className="task-one mb-3">
          <h4>
            <span>6.1</span> Write these verbs with <strong>-s</strong>or{" "}
            <strong>-es</strong>.
          </h4>
          <p className="table row">
            <ol className="">
              <li>
                (read) she
                <input
                  className="border"
                  value="reads"
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />{" "}
              </li>
              <li>
                (think) he
                <input
                  className="border"
                  onChange={(e) => setQ1(e.target.value)}
                  style={{
                    background: q1.trim() === "thinks" ? "#198754" : "white",
                    color: q1.trim() === "thinks" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (fly) it
                <input
                  className="border"
                  onChange={(e) => setQ2(e.target.value)}
                  style={{
                    background: q2.trim() === "flies" ? "#198754" : "white",
                    color: q2.trim() === "flies" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (dance) he
                <input
                  className="border"
                  onChange={(e) => setQ3(e.target.value)}
                  style={{
                    background: q3.trim() === "dances" ? "#198754" : "white",
                    color: q3.trim() === "dances" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (have) she
                <input
                  className="border"
                  onChange={(e) => setQ4(e.target.value)}
                  style={{
                    background: q4.trim() === "has" ? "#198754" : "white",
                    color: q4.trim() === "has" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (finish) it
                <input
                  className="border"
                  onChange={(e) => setQ5(e.target.value)}
                  style={{
                    background: q5.trim() === "finishes" ? "#198754" : "white",
                    color: q5.trim() === "finishes" ? "white" : "black",
                  }}
                />{" "}
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-two mb-3">
          <h4>
            <span>6.2</span> Complete the sentences about the people in the
            picures. Use:
          </h4>
          <p className="table row">
            <ul className="border d-flex justify-content-evenly">
              <li>eat</li>
              <li>go</li>
              <li>live</li>
              <li className="strike">play</li>
              <li>play</li>
              <li>sleep</li>
            </ul>
            <img src={imageOne} />
            <ol className="">
              <li>
                <input
                  className="border"
                  value="He plays"
                  disabled
                  onChange={(e) => setQ6(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                the piano.
              </li>
              <li>
                They
                <input
                  className="border"
                  onChange={(e) => setQ7(e.target.value)}
                  style={{
                    background: q7.trim() === "live" ? "#198754" : "white",
                    color: q7.trim() === "live" ? "white" : "black",
                  }}
                />
                in a very big house.
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ8(e.target.value)}
                  style={{
                    background: q8.trim() === "She eats" ? "#198754" : "white",
                    color: q8.trim() === "She eats" ? "white" : "black",
                  }}
                />
                a lot of fruit.
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ9(e.target.value)}
                  style={{
                    background: q9.trim() === "He plays" ? "#198754" : "white",
                    color: q9.trim() === "He plays" ? "white" : "black",
                  }}
                />
                tennis.
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ10(e.target.value)}
                  style={{
                    background: q10.trim() === "They go" ? "#198754" : "white",
                    color: q10.trim() === "They go" ? "white" : "black",
                  }}
                />
                to the cinema a lot.
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ11(e.target.value)}
                  style={{
                    background:
                      q11.trim() === "He sleeps"
                        ? "#198754"
                        : q11.trim() === "'s having"
                        ? "#198754"
                        : "white",
                    color:
                      q11.trim() === "He sleeps"
                        ? "white"
                        : q11.trim() === "'s he laughing"
                        ? "white"
                        : "black",
                  }}
                />
                seven hours a night.
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-three mb-3 row ">
          <h4>
            <span>6.3</span> Complete the sentences. Use:
          </h4>
          <p className="table row">
            <ul className="border d-flex justify-content-evenly">
              <li>boil</li>
              <li>close</li>
              <li>cost</li>
              <li>cost</li>
              <li>like</li>
              <li>like</li>
              <li>meet</li>
              <li>open</li>
              <li className="strike">speak</li>
              <li>teach</li>
              <li>wash</li>
            </ul>
            <ol>
              <li>
                Maria
                <input
                  className="border"
                  value="speaks"
                  disabled
                  onChange={(e) => setQ12(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                four langauges.
              </li>
              <li>
                The shops in the city centre usually
                <input
                  className="border"
                  onChange={(e) => setQ13(e.target.value)}
                  style={{
                    background: q13.trim() === "open" ? "#198754" : "white",
                    color: q13.trim() === "open" ? "white" : "black",
                  }}
                />
                at 9 o'clock in the morning.
              </li>
              <li>
                The City Museum
                <input
                  className="border"
                  onChange={(e) => setQ14(e.target.value)}
                  style={{
                    background: q14.trim() === "opens" ? "#198754" : "white",
                    color: q14.trim() === "opens" ? "white" : "black",
                  }}
                />
                at 5 o'clock in the evening.
              </li>
              <li>
                Tina is a teacher. She
                <input
                  className="border"
                  onChange={(e) => setQ15(e.target.value)}
                  style={{
                    background: q15.trim() === "teaches" ? "#198754" : "white",
                    color: q15.trim() === "teaches" ? "white" : "black",
                  }}
                />
                mathematics to young children.
              </li>
              <li>
                My job is very interesting. I
                <input
                  className="border"
                  onChange={(e) => setQ16(e.target.value)}
                  style={{
                    background: q16.trim() === "meet" ? "#198754" : "white",
                    color: q16.trim() === "meet" ? "white" : "black",
                  }}
                />
                a lot of people.
              </li>
              <li>
                Peter's car is always dirty. He never
                <input
                  className="border"
                  onChange={(e) => setQ17(e.target.value)}
                  style={{
                    background: q17.trim() === "cleans" ? "#198754" : "white",
                    color: q17.trim() === "cleans" ? "white" : "black",
                  }}
                />
                it.
              </li>
              <li>
                Food is expensive. It
                <input
                  className="border"
                  onChange={(e) => setQ18(e.target.value)}
                  style={{
                    background: q18.trim() === "costs" ? "#198754" : "white",
                    color: q18.trim() === "costs" ? "white" : "black",
                  }}
                />
                a lot of money.
              </li>
              <li>
                Shoes are expensive. They
                <input
                  className="border"
                  onChange={(e) => setQ19(e.target.value)}
                  style={{
                    background: q19.trim() === "cost" ? "#198754" : "white",
                    color: q19.trim() === "cost" ? "white" : "black",
                  }}
                />
                a lot of money.
              </li>
              <li>
                Water
                <input
                  className="border"
                  onChange={(e) => setQ20(e.target.value)}
                  style={{
                    background: q20.trim() === "boils" ? "#198754" : "white",
                    color: q20.trim() === "boils" ? "white" : "black",
                  }}
                />
                at 100 degrees Celsius.
              </li>
              <li>
                Laura and I are good friends. I
                <input
                  className="border"
                  onChange={(e) => setQ21(e.target.value)}
                  style={{
                    background: q21.trim() === "like" ? "#198754" : "white",
                    color: q21.trim() === "like" ? "white" : "black",
                  }}
                />
                her and she
                <input
                  className="border"
                  onChange={(e) => setQ22(e.target.value)}
                  style={{
                    background: q22.trim() === "likes" ? "#198754" : "white",
                    color: q22.trim() === "likes" ? "white" : "black",
                  }}
                />{" "}
                me.
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-four mb-3">
          <h4>
            <span>5.4</span> Write sentences from these words. Use the right
            form of the verb
            <span>
              <strong> arrive </strong> or <strong> arrives </strong> etc.
            </span>
          </h4>
          <p className="table row">
            <ol className="border">
              <li>
                (always / early / Sue / arrive)
                <input
                  className="border"
                  value="Sue always arrives early."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                (to the cinema / never / I / go) I
                <input
                  className="border"
                  onChange={(e) => setQ23(e.target.value)}
                  style={{
                    background:
                      q23.trim() === "never go to the cinema."
                        ? "#198754"
                        : "white",
                    color:
                      q23.trim() === "never go to the cinema."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (work / Martina / hard / always)
                <input
                  className="border"
                  onChange={(e) => setQ24(e.target.value)}
                  style={{
                    background:
                      q24.trim() === "Martina works hard always."
                        ? "#198754"
                        : q24.trim() === "Martina always works hard."
                        ? "#198754"
                        : "white",
                    color:
                      q24.trim() === "Martina works hard always."
                        ? "white"
                        : q24.trim() === "Martina always works hard."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (like / chocolate / children / usually)
                <input
                  className="border"
                  onChange={(e) => setQ25(e.target.value)}
                  style={{
                    background:
                      q25.trim() === "Children usually like chocolate."
                        ? "#198754"
                        : // : q25.trim() === "No, it's not."
                          // ? "#198754"
                          // : q25.trim() === "No, it isn't."
                          // ? "#198754"
                          "white",
                    color:
                      q25.trim() === "Children usually like chocolate."
                        ? "white"
                        : // : q25.trim() === "No, it's not."
                          // ? "white"
                          // : q25.trim() === "No, it isn't."
                          // ? "white"
                          "black",
                  }}
                />
              </li>
              <li>
                (Jackie / parties / enjoy / always)
                <input
                  className="border"
                  onChange={(e) => setQ26(e.target.value)}
                  style={{
                    background:
                      q26.trim() === "Jackie always enjoys parties."
                        ? "#198754"
                        : "white",
                    color:
                      q26.trim() === "Jackie always enjoys parties."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (often / people's names / I / forget)
                <input
                  className="border"
                  onChange={(e) => setQ27(e.target.value)}
                  style={{
                    background:
                      q27.trim() === "I often forget people's names."
                        ? "#198754"
                        : "white",
                    color:
                      q27.trim() === "I often forget people's names."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (TV / Sam / watch / never)
                <input
                  className="border"
                  onChange={(e) => setQ28(e.target.value)}
                  style={{
                    background:
                      q28.trim() === "Sam never watches TV."
                        ? "#198754"
                        : "white",
                    color:
                      q28.trim() === "Sam never watches TV."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (usually / dinner / we / have / at 7.30 )
                <input
                  className="border"
                  onChange={(e) => setQ29(e.target.value)}
                  style={{
                    background:
                      q29.trim() === "We usually have dinner at 7.30."
                        ? "#198754"
                        : "white",
                    color:
                      q29.trim() === "We usually have dinner at 7.30."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (Kate / always / nice clothes / wear)
                <input
                  className="border"
                  onChange={(e) => setQ30(e.target.value)}
                  style={{
                    background:
                      q30.trim() === "Kate always wears nice clothes."
                        ? "#198754"
                        : "white",
                    color:
                      q30.trim() === "Kate always wears nice clothes."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-four mb-3">
          <h4>
            <span>5.4</span> Write sentences about yourself. Use
            <span>
              <strong> always / never / often / usually / sometimes. </strong>
            </span>
          </h4>
          <p className="table row">
            <ol className="border">
              <li>
                (watch TV in the evening)
                <input
                  className="border"
                  value="I usually watch TV in the evening."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                (read in bed) I
                <input
                  className="border"
                  onChange={(e) => setQ31(e.target.value)}
                  style={{
                    background: q31.trim() !== "" ? "#198754" : "white",
                    color: q31.trim() !== "" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (get up before 7 o'clock)
                <input
                  className="border"
                  onChange={(e) => setQ32(e.target.value)}
                  style={{
                    background: q32.trim() !== "" ? "#198754" : "white",
                    color: q32.trim() !== "" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (go to work/school by bus)
                <input
                  className="border"
                  onChange={(e) => setQ33(e.target.value)}
                  style={{
                    background: q33.trim() !== "" ? "#198754" : "white",
                    color: q33.trim() !== "" ? "white" : "black",
                  }}
                />
              </li>
              <li>
                (drink coffee in the morning)
                <input
                  className="border"
                  onChange={(e) => setQ34(e.target.value)}
                  style={{
                    background: q34.trim() !== "" ? "#198754" : "white",
                    color: q34.trim() !== "" ? "white" : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>
      </div>
    </>
  );
}

export default LessonSix;
